import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Button } from "../components/ui/button";
import { Input, Label } from "../components/ui/input";
import { toast } from "sonner";
import Footer from "../components/Footer";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ company_name: "", name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);

  React.useEffect(() => {
    document.documentElement.classList.add("dark");
  }, []);

  const onSubmit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await register(form);
      toast.success("Welcome to Lestari. Let's onboard your entity.");
      navigate("/onboarding");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Registration failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground dark grid-bg">
      <div className="flex-1 flex items-center justify-center p-6">
      <div className="w-full max-w-md card-flat p-8 space-y-6 bg-surface">
        <div>
          <div className="label-eyebrow mb-3">Register</div>
          <h2 className="font-display text-3xl font-bold tracking-tight">Onboard your organisation.</h2>
          <p className="text-muted-foreground text-sm mt-2">
            Already have an account?{" "}
            <Link to="/login" className="text-accent hover:underline" data-testid="login-link">Sign in</Link>
          </p>
        </div>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="register-form">
          <div>
            <Label>Company name</Label>
            <Input
              required
              data-testid="register-company"
              value={form.company_name}
              onChange={(e) => setForm({ ...form, company_name: e.target.value })}
              placeholder="Acme Corporation Pte Ltd"
            />
          </div>
          <div>
            <Label>Your name</Label>
            <Input
              required
              data-testid="register-name"
              value={form.name}
              onChange={(e) => setForm({ ...form, name: e.target.value })}
              placeholder="Aishah Tan"
            />
          </div>
          <div>
            <Label>Email</Label>
            <Input
              type="email"
              required
              data-testid="register-email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              placeholder="aishah@acme.sg"
            />
          </div>
          <div>
            <Label>Password (8+ chars)</Label>
            <Input
              type="password"
              required
              minLength={8}
              data-testid="register-password"
              value={form.password}
              onChange={(e) => setForm({ ...form, password: e.target.value })}
            />
          </div>
          <Button type="submit" variant="primary" size="lg" className="w-full" disabled={busy} data-testid="register-submit-btn">
            {busy ? "Creating…" : "Create account & continue"}
          </Button>
        </form>
      </div>
      </div>
      <Footer />
    </div>
  );
}
